var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('Leaderboard',{attrs:{"challenge-id":_vm.challengeId,"by-team-default":_vm.byTeamDefault,"default-task":_vm.defaultTask}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }